import { Component, OnInit } from '@angular/core';
import { FirestoreService } from '../../services/firestore/firestore.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { startWith } from 'rxjs/internal/operators/startWith';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-alumnos',
  templateUrl: './alumnos.component.html',
  styleUrls: ['./alumnos.component.scss']
})
export class AlumnosComponent implements OnInit {
  /**
   * Variable que indica la pagina en la que te encuentras
   */
  p = 1;
  public tipoUsuario = false;
  public alumnos = [];
  public documentId = null;
  public currentStatus = 1;
  public newAlumnForm = new FormGroup({
    nombre_alum: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z\\s]+$')]),
    ape_pat_alum: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z\\s]+$')]),
    ape_mat_alum: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z\\s]+$')]),
    edad_alum: new FormControl('', [Validators.required, Validators.pattern('^[1-7]{1}')]),
    rut_alum: new FormControl('', [Validators.pattern('^[1-7,-]+$')]),
    sexo_alum: new FormControl('', [Validators.required]),
    nivel_educ: new FormControl('', [Validators.required]),
    id: new FormControl('')
  });
  filteredNivel: Observable<any[]>;
  filteredSexo: Observable<any[]>;

  /**
   * Opciones a mostrar en nivel
   */
  opcionesNivel = [
    {
      nombre: 'Kinder'
    },
    {
      nombre: 'Pre Kinder'
    },
    {
      nombre: 'Medio Mayor'
    },
    {
      nombre: 'Medio Menor'
    },
    {
      nombre: 'Sala Cuna Mayor'
    },
    {
      nombre: 'Sala Cuna Menor'
    },
  ];

  /**
   * Opciones a mostrar en sexo
   */
  opcionesSexo = [
    {
      nombre: 'Masculino '
    },
    {
      nombre: 'Femenino '
    },
    {
      nombre: 'No definido'
    }
  ];

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  constructor(private firestoreService: FirestoreService) {
    this.newAlumnForm.setValue({
      id: '',
      nombre_alum: '',
      ape_pat_alum: '',
      ape_mat_alum: '',
      edad_alum: '',
      rut_alum: '',
      sexo_alum: '',
      nivel_educ: ''
    });
  }

  ngOnInit() {
    this.firestoreService.getAlums().subscribe(alumnosSnapshot => {
      this.alumnos = [];
      alumnosSnapshot.forEach((alumnosData: any) => {
        this.alumnos.push({
          id: alumnosData.payload.doc.id,
          data: alumnosData.payload.doc.data()
        });
        this.alumnos.sort((a, b) => {
          return a.data.nombre_alum.localeCompare(b.data.nombre_alum);
        });
      });
    });
    this.filtroNivel();
    this.filtroSexo();
    this.validarAcciones();
  }

  public newalumnos(form, documentId = this.documentId) {
    if (this.currentStatus === 1) {
      const data = {
        nombre_alum: this.capitalize(form.nombre_alum.toLowerCase()),
        ape_pat_alum: this.capitalize(form.ape_pat_alum.toLowerCase()),
        ape_mat_alum: this.capitalize(form.ape_mat_alum.toLowerCase()),
        edad_alum: form.edad_alum,
        rut_alum: form.rut_alum,
        sexo_alum: form.sexo_alum,
        nivel_educ: form.nivel_educ
      };
      this.firestoreService.createAlum(data).then(
        () => {
          this.newAlumnForm.reset();
          this.filtroNivel();
          Swal.fire(
            'Creado!',
            'El registro se creo correctamente.',
            'success'
          );
        },
        error => {
        }
      );
    } else {
      const data = {
        nombre_alum: this.capitalize(form.nombre_alum.toLowerCase()),
        ape_pat_alum: this.capitalize(form.ape_pat_alum.toLowerCase()),
        ape_mat_alum: this.capitalize(form.ape_mat_alum.toLowerCase()),
        edad_alum: form.edad_alum,
        rut_alum: form.rut_alum,
        sexo_alum: form.sexo_alum,
        nivel_educ: form.nivel_educ
      };

      this.firestoreService.updateAlum(documentId, data).then(
        () => {
          this.currentStatus = 1;
          this.newAlumnForm.reset();
          this.filtroNivel();
          Swal.fire(
            'Editado!',
            'El registro se edito correctamente.',
            'success'
          );
        },
        error => {
        }
      );
    }
  }

  public editAlumno(documentId) {
    const editSubscribe = this.firestoreService.getAlum(documentId).subscribe((alumno) => {
      this.currentStatus = 2;
      this.documentId = documentId;
      this.newAlumnForm.setValue({
        id: documentId,
        nombre_alum: alumno.payload.data()['nombre_alum'],
        ape_pat_alum: alumno.payload.data()['ape_pat_alum'],
        ape_mat_alum: alumno.payload.data()['ape_mat_alum'],
        edad_alum: alumno.payload.data()['edad_alum'],
        rut_alum: alumno.payload.data()['rut_alum'],
        sexo_alum: alumno.payload.data()['sexo_alum'],
        nivel_educ: alumno.payload.data()['nivel_educ']
      });
      editSubscribe.unsubscribe();
    });
  }

  capitalize(valor) {
    return valor.charAt(0).toUpperCase() + valor.slice(1);
  }

  private _filterNivel(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.opcionesNivel.filter(option => option.nombre.toLowerCase().indexOf(filterValue) === 0);
  }

  private _filterSexo(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.opcionesSexo.filter(option => option.nombre.toLowerCase().indexOf(filterValue) === 0);
  }

  public delAlumno(documentId) {

    Swal.fire({
      title: 'Estas seguro?',
      text: "No podrás revertir esta accion!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, borrar!'
    }).then((result) => {
      if (result.value) {
        this.firestoreService.deleteAlum(documentId).then(() => {
          Swal.fire(
            'Borrado!',
            'El registro fue eliminado.',
            'success'
          );
        }, (error) => {
        });
      }
    });

  }

  /**
  * Segun lo que se ingrese en el input de nivel se actualizaran las opciones a mostrar
  */
  filtroNivel() {
    this.filteredNivel = this.newAlumnForm.controls.nivel_educ.valueChanges.pipe(
      startWith(''),
      // map(value => typeof value === 'string' ? value : value.nombre),
      map(name => name ? this._filterNivel(name) : this.opcionesNivel.slice())
    );
  }
  /**
  * Segun lo que se ingrese en el input de nivel se actualizaran las opciones a mostrar
  */
  filtroSexo() {
    this.filteredSexo = this.newAlumnForm.controls.sexo_alum.valueChanges.pipe(
      startWith(''),
      // map(value => typeof value === 'string' ? value : value.nombre),
      map(name => name ? this._filterSexo(name) : this.opcionesSexo.slice())
    );
  }

  limpiar() {
    this.newAlumnForm.reset();
    this.filtroNivel();
  }

  validarAcciones() {
    if (sessionStorage.getItem('usuario')) {
      const user: any = JSON.parse(sessionStorage.getItem('usuario'));
      this.firestoreService.getUsuari(user.i.user.uid).subscribe(data => {
        const usuario: any = data.payload.data();
        if (usuario.perfil_usuar !== 'Administrador') {
          this.tipoUsuario = true;
          Swal.fire(
            'Aviso!',
            'Usuario Estándar, sin privilegios para realizar cambios, favor comuníquese con el administrador.',
            'warning'
          );
        } else {
          this.tipoUsuario = false;
        }
      });
    } else {
      this.tipoUsuario = false;
    }
  }
}
